export default __webpack_public_path__ + "static/media/Icon-Bereavement.e0c323f2.svg";